/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const ERROR_CONTRIBUTION_LIMIT = 'ERROR_CONTRIBUTION_LIMIT';
export const RECEIVED_CONTRIBUTION_LIMIT = 'RECEIVED_CONTRIBUTION_LIMIT';
export const REQUESTED_CONTRIBUTION_LIMIT = 'REQUESTED_CONTRIBUTION_LIMIT';
export const RECEIVED_CONTRIBUTION_PERIOD = 'RECEIVED_CONTRIBUTION_PERIOD';
export const REQUESTED_CONTRIBUTION_PERIOD = 'REQUESTED_CONTRIBUTION_PERIOD';
export const ERROR_CONTRIBUTION_PERIOD = 'ERROR_CONTRIBUTION_PERIOD';

export const errorContributionLimit = (error) => ({
  type: ERROR_CONTRIBUTION_LIMIT,
  error
});

export const receivedContributionLimit = (response) => ({
  type: RECEIVED_CONTRIBUTION_LIMIT,
  payload: {
    ...response
  }
});

export const requestedContributionLimit = () => ({
  type: REQUESTED_CONTRIBUTION_LIMIT
});

export const errorContributionPeriod = (error) => ({
  type: ERROR_CONTRIBUTION_PERIOD,
  error
});

export const receivedContributionPeriod = (response) => ({
  type: RECEIVED_CONTRIBUTION_PERIOD,
  payload: {
    ...response
  }
});

export const requestedContributionPeriod = () => ({
  type: REQUESTED_CONTRIBUTION_PERIOD
});
